<mat-card class="display-card">
    <mat-card-header>
        <div class="header-content">
            <div class="display-title">
                <mat-icon>tv</mat-icon>
                <mat-card-title>{{ display.deviceName || 'Display' }}</mat-card-title>
            </div>
        </div>
    </mat-card-header>

    <mat-card-content>
        <div class="display-info">
            <div class="info-row">
                <strong>Display ID:</strong>
                <span class="small-text">{{ display.id }}</span>
            </div>
            <div class="info-row">
                <strong>Status:</strong>
                <span class="status-badge" [class]="'status-' + display.deviceStatus?.toLowerCase()">
                    {{ display.deviceStatus }}
                </span>
            </div>
            <div class="info-row">
                <strong>Online:</strong>
                <span class="status-badge" [class]="display.isOnline ? 'status-active' : 'status-inactive'">
                    {{ display.isOnline ? 'Online' : 'Offline' }}
                </span>
            </div>

            @if (display.deviceDescription) {
            <div class="info-row">
                <strong>Description:</strong>
                <span>{{ display.deviceDescription }}</span>
            </div>
            }
        </div>

        @if (display.deviceHardwareID || display.macAddress || display.piDeviceId || display.lastHeartbeatAt) {
        <div class="hardware-section">
            <h4>Hardware Information</h4>
            <div class="config-grid">
                @if (display.deviceHardwareID) {
                <div class="config-item">
                    <strong>Hardware ID</strong>
                    <span class="mono">{{ display.deviceHardwareID }}</span>
                </div>
                }
                @if (display.macAddress) {
                <div class="config-item">
                    <strong>MAC Address</strong>
                    <span class="mono">{{ display.macAddress }}</span>
                </div>
                }
                @if (display.piDeviceId) {
                <div class="config-item">
                    <strong>Pi Device ID</strong>
                    <span>{{ display.piDeviceId }}</span>
                </div>
                }
                @if (display.lastHeartbeatAt) {
                <div class="config-item">
                    <strong>Last Heartbeat</strong>
                    <span>{{ display.lastHeartbeatAt | date:'medium' }}</span>
                </div>
                }
            </div>
        </div>
        }
    </mat-card-content>

    <mat-card-actions class="card-actions">
        <button mat-stroked-button color="primary" (click)="onEdit()" [disabled]="isProcessing" class="action-button">
            <mat-icon>edit</mat-icon>
            Edit
        </button>
        @if (isAdmin()) {
        <button mat-stroked-button color="accent" (click)="onTestHeartbeat()" [disabled]="isProcessing"
            class="action-button">
            <mat-icon>favorite</mat-icon>
            Test Heartbeat
        </button>
        }
        <button mat-stroked-button color="accent" (click)="onUnassign()" [disabled]="isProcessing"
            class="action-button">
            <mat-icon>link_off</mat-icon>
            Unassign
        </button>
        <button mat-stroked-button color="warn" (click)="onDelete()" [disabled]="isProcessing" class="action-button">
            <mat-icon>delete</mat-icon>
            Remove
        </button>
    </mat-card-actions>
</mat-card>